import { render } from "./CreateKubernetesCluster.vue?vue&type=template&id=4b00ec84&scoped=true"
import script from "./CreateKubernetesCluster.vue?vue&type=script&lang=js"
export * from "./CreateKubernetesCluster.vue?vue&type=script&lang=js"

import "./CreateKubernetesCluster.vue?vue&type=style&index=0&id=4b00ec84&scoped=true&lang=less"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b00ec84"]])

export default __exports__